import React from 'react';
import { ThumbFrame, INK } from './thumbFrame';

/** Animated background system — geometric shapes drifting on a canvas. */
const AnimatedBgThumb: React.FC = () => (
  <ThumbFrame label="Animated Background System">
    {/* Screen frame */}
    <rect x="58" y="52" width="284" height="196" rx="14" fill="#ffffff" stroke={INK} strokeWidth="1.8" />

    {/* Clip shapes to the screen */}
    <defs>
      <clipPath id="animScreenClip">
        <rect x="58" y="52" width="284" height="196" rx="14" />
      </clipPath>
    </defs>

    <g clipPath="url(#animScreenClip)">
      {/* Orbiting ring */}
      <circle cx="140" cy="120" r="26" fill="none" stroke={INK} strokeWidth="2">
        <animateTransform attributeName="transform" type="translate" values="0 0; 30 20; 0 0" dur="7s" repeatCount="indefinite" />
      </circle>

      {/* Rotating square */}
      <rect x="240" y="90" width="40" height="40" rx="6" fill={INK} opacity="0.1">
        <animateTransform attributeName="transform" type="rotate" from="0 260 110" to="360 260 110" dur="9s" repeatCount="indefinite" />
      </rect>

      {/* Filled circle drifting */}
      <circle cx="270" cy="190" r="16" fill={INK}>
        <animateTransform attributeName="transform" type="translate" values="0 0; -24 -18; 0 0" dur="6s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="1;0.5;1" dur="6s" repeatCount="indefinite" />
      </circle>

      {/* Triangle */}
      <path d="M150 210 l22 -34 l22 34 Z" fill="none" stroke={INK} strokeWidth="2">
        <animateTransform attributeName="transform" type="rotate" from="0 172 193" to="-360 172 193" dur="11s" repeatCount="indefinite" />
      </path>

      {/* Small dots */}
      {[[100, 200], [320, 80], [200, 96]].map(([cx, cy], i) => (
        <circle key={i} cx={cx} cy={cy} r="4" fill={INK} opacity="0.4">
          <animate attributeName="cy" values={`${cy};${cy - 16};${cy}`} dur={`${4 + i}s`} repeatCount="indefinite" />
        </circle>
      ))}
    </g>
  </ThumbFrame>
);

export default AnimatedBgThumb;
